<div class="copilot-message-container" *ngIf="insights">
  <div class="copilot-message-header">
    <span class="copilot-message-icon">
      <img [src]="'svg/insights-icon.svg' | assetVersion" />
    </span>
    <div class="copilot-insights-title">
      Insights
    </div>
  </div>
  <div class="copilot-message-content">
    <app-markdown [rawMarkdown]="insights">
    </app-markdown>
  </div>
</div>